var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"connect-with-fb",on:{"click":function($event){return _vm.$emit('click', $event)}}},[_c('img',{staticClass:"fb-icon",attrs:{"src":require('@/assets/icons/f.svg')}}),_c('span',{staticClass:"fb-text"},[_vm._v(" "+_vm._s(_vm.buttonText)+" ")])])
}
var staticRenderFns = []

export { render, staticRenderFns }